import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Dropdown } from '../../forms/Dropdown/Dropdown.es.js';
import { ServiceIcon } from '../ServiceIcon/ServiceIcon.es.js';

const Styles = labelStyles("ServiceDropdown", {
  serviceIcon: css`
    &[data-disabled] {
      opacity: 0.6;
    }
  `
});
const ServiceDropdown = (_a) => {
  var { getIconUrlForItem } = _a, props = __rest(_a, ["getIconUrlForItem"]);
  const renderIcon = (item) => !!item && jsx(
    "span",
    { css: Styles.serviceIcon, "data-disabled": props.isDisabled ? "" : void 0, "data-zds": true },
    jsx(ServiceIcon, { "aria-hidden": true, serviceName: props.getLabelForItem(item), size: "small", src: getIconUrlForItem(item) })
  );
  return jsx(Dropdown, Object.assign({}, props, { renderIcon }));
};

export { ServiceDropdown };
//# sourceMappingURL=ServiceDropdown.es.js.map
